module.exports = __webpack_public_path__ + "static/media/client.c729af78.png";